/**
 * Utility functions for time formatting
 */

/**
 * Format a timestamp to relative time (e.g., "5 min ago", "2 hours ago")
 * Handles both past and future timestamps
 */
export const formatRelativeTime = (timestamp) => {
  if (!timestamp) return 'Unknown';

  const now = new Date();
  const time = new Date(timestamp);
  const diffMs = now - time;
  const absDiffMs = Math.abs(diffMs);
  const diffMins = Math.floor(absDiffMs / 60000);
  const diffHours = Math.floor(absDiffMs / 3600000);
  const diffDays = Math.floor(absDiffMs / 86400000);

  // Handle future timestamps (negative diff)
  if (diffMs < 0) {
    if (diffMins < 1) return 'In a moment';
    if (diffMins < 60) return `In ${diffMins} min`;
    if (diffHours < 24) return `In ${diffHours} hour${diffHours > 1 ? 's' : ''}`;
    return `In ${diffDays} day${diffDays > 1 ? 's' : ''}`;
  }

  // Handle past timestamps
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  
  // For older dates, show the actual date
  return time.toLocaleDateString();
};

/**
 * Format temperature with unit
 */
export const formatTemperature = (temp, unit = 'celsius') => {
  if (temp === null || temp === undefined) return 'N/A';
  const rounded = Math.round(temp * 10) / 10;
  return unit === 'fahrenheit' ? `${rounded}°F` : `${rounded}°C`;
};

/**
 * Format humidity percentage
 */
export const formatHumidity = (humidity) => {
  if (humidity === null || humidity === undefined) return 'N/A';
  return `${Math.round(humidity)}%`;
};

